module.exports = "/virtual-football/img/video/clubs/france/bordeaux.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/img/video/clubs/france/bordeaux.png
// module id = 289
// module chunks = 6